import Vue from 'vue';
import VueI18n from 'vue-i18n';
import { getStoredLanguage, persistLanguage } from './language';
import recentOverrides from './recentOverrides';
import googleAuthTranslations from './googleAuthTranslations';

Vue.use(VueI18n);

// 各个国家的key
const localeKeys = [
  'en', 'zh-CN', 'ko', 'jp',
  'vi', 'hi', 'th', 'ru', 'es', 'fr', 'de', 'it'
];

const desktopMobilePageLabels = {
  en: 'Mobile Page',
  'zh-CN': '手机版页面',
  ko: '모바일 페이지',
  jp: 'モバイルページ',
  vi: 'Trang di động',
  hi: 'मोबाइल पेज',
  th: 'หน้ามือถือ',
  ru: 'Мобильная версия',
  es: 'Página móvil',
  fr: 'Version mobile',
  de: 'Mobile Seite',
  it: 'Pagina mobile'
};

const messages = {};
const mergeDeep = (target, source) => {
  Object.keys(source || {}).forEach(key => {
    if (source[key] && typeof source[key] === 'object' && !Array.isArray(source[key])) {
      target[key] = mergeDeep({ ...(target[key] || {}) }, source[key]);
    } else target[key] = source[key];
  });
  return target;
};
for (const key of localeKeys) {
  try {
    const langObj = require(`./locales/${key}`).default;
    messages[key] = mergeDeep({ ...langObj }, recentOverrides[key] || {});
    messages[key] = mergeDeep(messages[key], {
      googleAuth: googleAuthTranslations[key] || googleAuthTranslations.en
    });
    messages[key].desktopMobilePage = desktopMobilePageLabels[key];
  } catch (error) {
    console.warn(`语言包 ${key} 加载失败:`, error);
  }
}

const initialLanguage = persistLanguage(getStoredLanguage());

export default new VueI18n({
  locale: initialLanguage, // 默认英语
  fallbackLocale: 'en',
  messages,
  silentTranslationWarn: true // 忽略翻译警告
});
